import {
  Component,
  computed,
  input,
  output,
  ViewChild,
} from '@angular/core';
import DOMPurify from 'dompurify';

import { QaiDialogComponent, QaiTabsComponent, QaiTabDirective } from '@qai/ui';
import { ICallDetailModal } from 'src/app/interfaces/icall-detail-modal';
import { ITabDetail } from 'src/app/interfaces/itab-detail';

@Component({
  selector: 'app-practice-call-details-modal',
  templateUrl: './practice-call-details-modal.component.html',
  styleUrls: ['./practice-call-details-modal.component.scss'],
  standalone: true,
  imports: [QaiDialogComponent, QaiTabsComponent, QaiTabDirective],
})
export class PracticeCallDetailsModalComponent {
  @ViewChild(QaiDialogComponent) private dialogRef!: QaiDialogComponent;

  callDetails = input<ICallDetailModal | null>(null);
  title = input<string>('');

  readonly modalOpened = output<void>();
  readonly modalClosed = output<void>();

  protected sortedTabs = computed<ITabDetail[]>(() =>
    [...(this.callDetails()?.callDetails ?? [])]
      .filter(tab => tab.tabTitle?.trim() && tab.tabText?.trim())
      .sort((a, b) => a.tabSequence - b.tabSequence)
  );

  open(): void {
    this.dialogRef.showModal();
    this.modalOpened.emit();
  }

  protected onAfterClose(): void {
    this.modalClosed.emit();
  }

  protected processTabText(text: string): string {
    if (!text) return '';

    text = DOMPurify.sanitize(text);

    const bulletImg = '<img src="assets/icons/checkmark.svg" alt="">';
    text = text.replace(/@@/g, bulletImg);
    text = text.replace(/\n/g, '<br/>');
    text = text.replace(/\*{1,2}(.+?)\*{1,2}/g, '<strong class="tab-heading">$1</strong>');

    return text;
  }
}